// extracted by mini-css-extract-plugin
module.exports = {"footer_link":"car_badge_unsure__footer_link__KqZwP text__text_align_center__2cSPH font__font_size_18__OV9XC font__font_weight_semi_bold__dpk06"};